import { useState, useCallback } from "react";
import { useSidebarModals } from "./useSidebarModals";

/**
 * useCollectionModals - Collection-specific modal state management
 *
 * Extends useSidebarModals with Collection-specific modals (share, confirm, notifications).
 */
export function useCollectionModals() {
  // Base sidebar modal state
  const baseModals = useSidebarModals();

  // Collection-specific modals
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  // Confirm dialog
  const [confirmDialog, setConfirmDialog] = useState({ show: false, message: "", onConfirm: null, onExclude: null, onChangeCategory: null });

  // Notification toast
  const [notification, setNotification] = useState({ message: "", type: "info", show: false });

  const openConfirmDialog = useCallback((message, onConfirm, onExclude = null, onChangeCategory = null) => {
    setConfirmDialog({ show: true, message, onConfirm, onExclude, onChangeCategory });
  }, []);

  const closeConfirmDialog = useCallback(() => {
    setConfirmDialog({ show: false, message: "", onConfirm: null, onExclude: null, onChangeCategory: null });
  }, []);

  const showNotification = useCallback((message, type = "info") => {
    setNotification({ message, type, show: true });
    setTimeout(() => setNotification(prev => ({ ...prev, show: false })), 3000);
  }, []);

  return {
    // Base modals (preview, marketplace, reminder, curate sidebar, banners, add game)
    ...baseModals,

    // Collection-specific
    showShareModal,
    setShowShareModal,
    shareUrl,
    setShareUrl,

    // Dialog/Notification
    confirmDialog,
    setConfirmDialog,
    openConfirmDialog,
    closeConfirmDialog,
    notification,
    setNotification,
    showNotification,
  };
}
